import { type DatabaseJSON } from '@databases/model/database';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import {
  getEntriesCount,
  getFieldsCount,
  getFilledCellsCount
} from './database-size/resolvers.ts';

export type DatabaseShareProgress = {
  type: 'database';
  rows: number;
  columns: number;
  filledCells: number;
};

export type DatabaseShareProgressReporter = (progress: DatabaseShareProgress) => void;

export const getDatabaseShareProgress = (
  database: DatabaseJSON
): DatabaseShareProgress => ({
  type: 'database',
  rows: getEntriesCount(database),
  columns: getFieldsCount(database),
  filledCells: getFilledCellsCount(database)
});

/**
 * Resolves the optional Confluence share-progress bridge before Databases starts
 * observing updates, keeping reporting inert when the host has not bound it.
 */
export const resolveDatabaseShareProgressReporter = async (): Promise<
  DatabaseShareProgressReporter | undefined
> => {
  try {
    const contentApi = await waitForContentAPI();
    const notifyShareCriteriaProgress =
      contentApi.confluenceAPI?.onboarding?.notifyShareCriteriaProgress;

    if (!notifyShareCriteriaProgress) {
      return;
    }

    return (progress) => {
      try {
        notifyShareCriteriaProgress(progress);
      } catch (e) {
        console.error('Failed to report database share progress:', e);
      }
    };
  } catch (e) {
    console.error('Failed to report database share progress:', e);
    return;
  }
};
